<template>
    <div id="app">
        <treeselect :multiple="true" :options="options" @close="onChange" :placeholder="placeholder" v-model="value" :max-height="200" @select="onSelect" @deselect="onDeselect" :disabled="tree_enable" :noOptionsText="noOptions" :limit="2" :limitText="limitTxt" :sort-value-by="sortValueBy" />
    </div>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import opData from '../../../static/api/selected-tree.json'
export default {
    // register the component
    name: 'Tree-Select',
    props: {
        tData: {
            type: Object,
            default: () => {}
        },
        defaultValue: String,
        defDisabled: false,
        limitTxt: {
            type: Function,
            default: function(count) {
                let c = 0
                c = count
                let res = '更多+' + c
                return res
            }
        }
    },
    components: { Treeselect },
    data() {
        return {
            value: [], //this.mockData(),
            options: this.getTreeData(),
            placeholder: this.defaultValue === undefined ? "请选择" : this.defaultValue,
            tree_enable: this.getDisabled(),
            noOptions: '没有数据',
            sortValueBy: 'INDEX', //ORDER_SELECTED,LEVEL,INDEX

        }
    },
    methods: {
        getTreeData(da) {
            if (da && da.data) {
                return da.data
            } else if (this.tData && this.tData.data) {
                return this.tData.data
            } else {
                return []
            }
        },
        getDisabled() {
            //console.log(this.defDisabled)
            return this.defDisabled
        },
        setDisable(isDisable) {
            this.tree_enable = isDisable
            //console.log(this.tree_enable)
        },
        //随机不重复取数
        getArrayItems(arr, num) {
            var temp_array = new Array();
            for (var index in arr) {
                temp_array.push(arr[index]);
            }
            var return_array = new Array();
            for (var i = 0; i < num; i++) {
                if (temp_array.length > 0) {
                    var arrIndex = Math.floor(Math.random() * temp_array.length);
                    return_array[i] = temp_array[arrIndex];
                    temp_array.splice(arrIndex, 1);
                } else {
                    break;
                }
            }
            return return_array;
        },
        mockData() {
            let mockData = ["001", "002", "003", "004", "005", "006", "007", "008", "009", "010"]
            return this.getArrayItems(mockData, 2)
        },
        onChange(value, instanceId) {
            // console.log(value)
            // console.log(instanceId)
            this.$emit('onTagChange', value)
        },
        onSelect(node, instanceId) {
            this.$emit('onSelected', node)
        },
        onDeselect(node, instanceId) {
            this.$emit('onDeSelected', node)
        },
        loadValue(da) {
            console.log('load da==========')
            console.log(da)
            var v = []
            if (da) {
                for (var i in da) {
                    //console.log(da[i])
                    if (da[i].selected) {
                        v.push(da[i].id)
                    }
                }
                this.value = v
            }
        },
        loadDefault(level) {
            console.log('loadDefault=========>')
            var v = []
            if (level) {
                let da = level.t2
                for (var i in da) {
                    //console.log(da[i])
                    if (da[i].selected) {
                        v.push(da[i].id)
                    }
                }
            } else {
                let da = this.tData.data
                for (var i in da) {
                    //console.log(da[i])
                    if (da[i].selected) {
                        v.push(da[i].id)
                    }
                }
            }



            // if (this.tData.data && this.tData.data.length > 0) {
            //     let da = this.tData.data
            //     for (var i in da) {
            //         console.log(da[i])
            //         if (da[i].selected) {
            //             v.push(da[i].id)
            //         }
            //     }
            // }
            console.log(v)
            this.value = v
        },
        showProvinceAndCity(option, value) {
             console.log("showProvinceAndCity===========================")
            // console.log(option)
            // console.log(value)
            this.$nextTick(() => {
                if (option[0].id && value) {
                    this.options = option
                    this.value = value
                }
            })

            console.log(this.options, this.value)
        },
        showData(val) {
            this.options = this.getTreeData(val)
            if (val.data) {
                this.$nextTick(() => {
                    this.loadValue(val.data)
                })

            } else {
                this.$nextTick(() => {
                    this.loadValue([])
                })

            }
        }

    },
    created() {
        //this.loadDefault()
        this.showData(this.tData)
    },
    watch: {
        tData: {
            handler(val) {
                this.showData(val)
            }

        },
    }
}
</script>